import * as filestack from 'filestack-js';
const client = filestack.init('AmXHoC0fuTbSNI27c9ezKz');
document.addEventListener('DOMContentLoaded', function(e) {

  /* --------------------------------------------------
                Single File Upload Init
  -------------------------------------------------- */
  const vdFilestackUploadInit = function(){
    const filestackerInputs = 'filestack';
    const dropzoneQueryString = '[data-filestack-dropzone="single"]';
    const dropzoneBoundaryQueryString = '[data-js="filestack-dropzone-boundary"]';
    const dropzoneBoundaryPostDroppedQueryString = '[data-js="filestack-dropzone-boundary-postdropped"]';
    const dropzoneBoundaryErrorQueryString = '[data-js="filestack-dropzone-boundary-error"]';
    const dropzoneBoundaryDroppingQueryString = '[data-js="filestack-dropzone-boundary-dropping"]';
    const dropzoneBoundaryErrorCountdownQueryString = '[data-js="filestack-dropzone-boundary-error-countdown"]';
    const dropzoneBoundaryActiveCountdowns = new Map();

    // Dropzone handlers
    const isDropzoned = function(){
      var div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();

    const handleSingleFileUpload = function(file, target) {
      // Get the accepted file types from the input
      const acceptedTypes = target.accept.split(',').map(type => type.trim());

      // Check if file type is accepted
      const isAcceptedType = acceptedTypes.some(type => {
        if (type.startsWith('.')) {
          return file.name.toLowerCase().endsWith(type.toLowerCase());
        } else {
          return file.type.match(new RegExp(type.replace('*', '.*')));
        }
      });

      if (!isAcceptedType) {
        // Show error state
        let dropzone = target.closest(dropzoneQueryString);
        let errorElement = dropzone.querySelector(dropzoneBoundaryErrorQueryString);
        let droppingElement = dropzone.querySelector(dropzoneBoundaryDroppingQueryString);
        let postDroppedElement = dropzone.querySelector(dropzoneBoundaryPostDroppedQueryString);

        // Hide all states
        droppingElement.classList.add('hidden');
        postDroppedElement.classList.add('hidden');
        
        // Show error state
        errorElement.classList.remove('hidden');

        // Clear any existing countdown for this dropzone
        if (dropzoneBoundaryActiveCountdowns.has(dropzone)) {
          clearInterval(dropzoneBoundaryActiveCountdowns.get(dropzone));
          dropzoneBoundaryActiveCountdowns.delete(dropzone);
        }

        // Add countdown
        let countdown = 3;
        const countdownElement = errorElement.querySelector(dropzoneBoundaryErrorCountdownQueryString);
        countdownElement.textContent = countdown;
        
        const countdownInterval = setInterval(() => {
          countdown--;
          countdownElement.textContent = countdown;
          
          if (countdown <= 0) {
            clearInterval(countdownInterval);
            dropzoneBoundaryActiveCountdowns.delete(dropzone);
            errorElement.classList.add('hidden');
          }
        }, 1000);

        // Store the interval
        dropzoneBoundaryActiveCountdowns.set(dropzone, countdownInterval);

        return;
      }

      const onProgress = (evt) => {
        target.previousElementSibling.innerHTML = `Uploading ${evt.totalPercent}%`;
      };

      // Create token for cancellation
      const token = {};

      // Setup cancel button handler
      const dropzone = target.closest(dropzoneQueryString);
      let cancelButton;
      if (dropzone) {
        cancelButton = dropzone.querySelector('[data-js="filestack-dropzone-boundary-cancel"]');
      }
      if (cancelButton) {
        cancelButton.addEventListener('click', (e) => {
          e.preventDefault();
          token['cancel']();
          // Reset UI state
          target.value = '';
          target.previousElementSibling.innerHTML = "Replace";
          // Hide post-dropped state
          const postDroppedElement = dropzone.querySelector(dropzoneBoundaryPostDroppedQueryString);
          postDroppedElement.classList.add('hidden');
        });
      }

      // Upload with token
      client.upload(file, { onProgress }, {}, token)
        .then(res => {
          target.value = '';
          target.previousElementSibling.previousElementSibling.innerHTML = "Replace";
          target.previousElementSibling.innerHTML = res.filename;
          target.previousElementSibling.setAttribute('href', res.url);
          target.nextElementSibling.value = res.url;
          target.nextElementSibling.nextElementSibling.value = res.filename;
          target.nextElementSibling.nextElementSibling.nextElementSibling.value = res.handle;
          let event = new CustomEvent('upload:done', {
            bubbles: true,
            detail: {
              handle: res.handle,
              url: res.url,
              filename: res.filename,
              filesize: file.size
            }
          });
          document.dispatchEvent(event);
          if (cancelButton) {
            cancelButton.classList.add('hidden');
          }
        })
        .catch(err => {
          console.error('Upload failed:', err);
        });
    };

    // Setup dropzone for single file upload
    if (isDropzoned) {
      let dropzones = document.querySelectorAll(dropzoneQueryString);
      Array.prototype.forEach.call(dropzones, function(dropzone) {
        let dropzoneBoundary = dropzone.querySelector(dropzoneBoundaryQueryString);
        let dropzoneBoundaryPostDropped = dropzone.querySelector(dropzoneBoundaryPostDroppedQueryString);
        let dropzoneBoundaryDropping = dropzone.querySelector(dropzoneBoundaryDroppingQueryString);
        let input = dropzone.querySelector(`[data-js="${filestackerInputs}"]`);

        if (!input) return; // Skip if no single file input found

        const dragEnterHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Only show dropping state if we're within the dropzone
          if (dropzone.contains(e.target)) {
            dropzoneBoundary.classList.remove('hidden');
            dropzoneBoundaryDropping.classList.remove('hidden');
          }
        };

        const dragLeaveHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Only hide dropping state if we're leaving the dropzone
          if (!dropzone.contains(e.relatedTarget)) {
            dropzoneBoundary.classList.add('hidden');
            dropzoneBoundaryDropping.classList.add('hidden');
          }
        };

        const dropHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Only handle drop if it's within the dropzone
          if (dropzone.contains(e.target)) {
            dropzoneBoundaryDropping.classList.add('hidden');
            dropzoneBoundaryPostDropped.classList.remove('hidden');

            const files = e.dataTransfer.files;
            if (files.length > 0) {
              handleSingleFileUpload(files[0], input);
            }
          }
        };

        // Only listen for drag events on the dropzone itself
        dropzone.addEventListener('dragenter', dragEnterHandler, false);
        dropzone.addEventListener('dragleave', dragLeaveHandler, false);
        dropzone.addEventListener('dragover', (e) => e.preventDefault(), false);
        dropzone.addEventListener('drop', dropHandler, false);
      });
    }

    // Handle file input change
    document.addEventListener('change', (e) => {
      if (e.target.dataset.js == filestackerInputs) {
        const inputFile = e.target.files.item(0);
        if (inputFile) {
          handleSingleFileUpload(inputFile, e.target);
        }
      }
    });
  }

  /* --------------------------------------------------
                Upload Multiple Init
  -------------------------------------------------- */
  const vdFilestackUploadMultipleInit = function(){
    const filestackerMultipleInputs = 'filestack-multiple-input';
    const dropzoneQueryString = '[data-filestack-dropzone="multiple"]';
    const dropzoneBoundaryQueryString = '[data-js="filestack-dropzone-boundary"]';

    // Dropzone handlers
    const isDropzoned = function(){
      var div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();
    const dropHandler = function(dropzoneBoundary, e){
      e.preventDefault();
      dropzoneBoundary.classList.add('hidden');
      uploadFiles(e);
    };
    const dragEnterHandler = function(dropzoneBoundary, e){
      e.preventDefault();
      dropzoneBoundary.classList.remove('hidden');
    };
    const dragLeaveHandler = function(dropzoneBoundary, e){
      e.preventDefault();
      dropzoneBoundary.classList.add('hidden');
    };

    // Dropzone setup
    if (isDropzoned) {
      let dropzones = document.querySelectorAll(dropzoneQueryString);
      Array.prototype.forEach.call(dropzones, function(dropzone) {
        let dropzoneBoundary = dropzone.querySelector(dropzoneBoundaryQueryString);
        dropzone.addEventListener('dragover', dragEnterHandler.bind(null, dropzoneBoundary), false);
        if (dropzoneBoundary) {
          dropzoneBoundary.addEventListener('dragleave', dragLeaveHandler.bind(null, dropzoneBoundary), false);
          dropzoneBoundary.addEventListener('dragdrop', dropHandler.bind(null, dropzoneBoundary), false);
          dropzoneBoundary.addEventListener('drop', dropHandler.bind(null, dropzoneBoundary), false);
        }
      })
    }

    function getPdfInfo(handle) {
      return fetch(`https://cdn.filestackcontent.com/AmXHoC0fuTbSNI27c9ezKz/pdfinfo/${handle}`)
        .then(response => response.json())
        .then(data => { return data; });
    }

    // Upload files
    const uploadFiles = function(e){
      let inputFiles = e.target.files || e.dataTransfer.files;
      let inputPrefix = e.target.dataset.prefix;
      let token = {};
      let container = e.target.closest(dropzoneQueryString);
      let multipleElement = container.querySelector('[data-js="filestack-multiple"]');
      let multipleElementTrigger = multipleElement.querySelector('[data-js="filestack-multiple-trigger"]');
      let multipleElementProgressContainer = multipleElement.querySelector('[data-js="filestack-multiple-progress-container"]');
      let multipleElementProgress = multipleElement.querySelector('[data-js="filestack-multiple-progress"]');
      let multipleElementControls = multipleElement.querySelector('[data-js="filestack-multiple-controls"]');
      let multipleElementControlsStatus = multipleElement.querySelector('[data-js="filestack-multiple-controls-status"]');
      let multipleElementControlsCancel = multipleElement.querySelector('[data-js="filestack-multiple-controls-cancel"]');

      // Cancel
      multipleElementControlsCancel.addEventListener('click', () => {
        token['cancel']();
        multipleElementTrigger.classList.remove('hidden');
        multipleElementProgressContainer.classList.add('hidden');
        multipleElementControls.classList.add('hidden');
      })

      // Progress
      let onProgress = (evt) => {
        multipleElementTrigger.classList.add('hidden');
        multipleElementProgressContainer.classList.remove('hidden');
        multipleElementControls.classList.remove('hidden');
        multipleElementProgress.style.width = evt.totalPercent + '%';
        multipleElementControlsStatus.innerHTML = 'Uploading ' + inputFiles.length + ' files: ' + evt.totalPercent + '%';
      };

      // Upload
      client.multiupload(inputFiles, { onProgress }, {}, token)
        .then(res => {
          multipleElementTrigger.classList.remove('hidden');
          multipleElementProgressContainer.classList.add('hidden');
          multipleElementControls.classList.add('hidden');

          Array.prototype.forEach.call(res, function(result) {
            if (result.status == "Stored") {
              let data = {}
              data[`${inputPrefix}__attachment_url`] =  result.url;
              data[`${inputPrefix}__attachment_filename`] = result.filename;
              data[`${inputPrefix}__attachment_handle`] = result.handle;

              getPdfInfo(result.handle)
                .then(pdfInfo => {
                  let pillElement = fieldNew.querySelector('[data-js="pill"]');
                  if (pillElement) {
                    pillElement.textContent = pdfInfo.pages === 1 ? `${pdfInfo.pages} page` : `${pdfInfo.pages} pages`;
                  }
                  const pdfPagesInput = fieldNew.querySelector(`input[data-js="pdf-pages"]`);
                  if (pdfPagesInput) {
                    pdfPagesInput.value = pdfInfo.pages;
                  }
                })
                .catch(error => {
                  console.error('Error getting PDF page count:', error);
                });

              // Add field
              let fieldNew = window.fieldAddDuplicatedNodeToPage(multipleElement, data);
              let fieldLink = fieldNew.getElementsByTagName('a')[0];
              fieldLink.textContent = result.filename;
              fieldLink.href = result.url;

              // Detect category
              let categorySelect = fieldNew.getElementsByTagName('select')[0];
              if (categorySelect != undefined) {
                let categoryFoundIndex = -1;
                Array.prototype.forEach.call(categorySelect.options, function(option, i) {
                  if (result.filename.replace(new RegExp(' ', 'g'), '_').toLowerCase().indexOf(option.value) != -1) {
                    categoryFoundIndex = i;
                  }
                })
                if (categoryFoundIndex != -1) {
                  categorySelect.value = categorySelect.options[categoryFoundIndex].value;
                }
              }
            }
          });
          e.target.value = ''
        })
        .catch(err => {
          console.log(err);
        });
      }

    // Trigger upload
    document.addEventListener('change', (e) => {
      if (e.target.dataset.js == filestackerMultipleInputs) {
        uploadFiles(e)
      }
    })
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  vdFilestackUploadInit();
  vdFilestackUploadMultipleInit();
});


/* --------------------------------------------------
                Picker Avatar Init
-------------------------------------------------- */
document.addEventListener('turbo:load', function(e) {
  const vdFilestackPickerAvatarPInit = function(){
    let filestackers = document.querySelectorAll('[data-js="filestack-picker-avatar"]');

    Array.prototype.forEach.call(filestackers, function(el, i) {
      el.addEventListener('click', (e) => {
        client.picker({
          onUploadDone: function(result){
            el.querySelector('img').setAttribute('src', result.filesUploaded[0].url);
            el.nextElementSibling.value = result.filesUploaded[0].url;
            el.nextElementSibling.nextElementSibling.value = result.filesUploaded[0].filename;
            el.nextElementSibling.nextElementSibling.nextElementSibling.value = result.filesUploaded[0].handle;
          },
          maxSize: 10 * 1024 * 1024,
          accept: 'image/*',
          uploadInBackground: false,
          fromSources: ["local_file_system"],
          transformations: {
            circle: true,
            force: true
          }
        }).open();
        e.preventDefault();
      });
    });
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  vdFilestackPickerAvatarPInit();
});